module.exports = __webpack_public_path__ + "static/media/Bar.da17fec3.PNG";